import { AuthEnums } from "models/enums";
import { DateHelper } from "utils/helpers";
import useAPIClientHelper from "./useAPIClientHelper";

function useCurrencyService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getExchangeRate = (currency: string, date: Date) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .CurrencyClient.Get(currency, DateHelper.convertDateToShortISOString(date))
      .then((res) => res.data);
  };

  return { getExchangeRate };
}

export default useCurrencyService;
